import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  KeyboardAvoidingView,
} from 'react-native';
import {
  Button,
  Icon,
  Input,
  Text,
} from 'react-native-elements';
import { Formik } from 'formik';
import {
  object as yupObject,
} from 'yup';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import Header from '../../misc/Header';

import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import { emailValidation, passwordValidation, password2Validation } from '../../../modules/validation/User';
// import { emailValidation, userNameValidation, passwordValidation } from '../../../modules/validation/User';

const validationSchema = yupObject().shape({
  email: emailValidation,
  // name: userNameValidation,
  password: passwordValidation,
  password2: password2Validation,
});

class SignUpForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {};
  }

  async handleSubmit(values, formikBag) {
    formikBag.setSubmitting(true);
    this.setState({ error: undefined });

    const { onSubmit } = this.props;
    const err = await onSubmit(values);
    if (err !== null) {
      // FIXME(clairbee): 'status' does not get updated. 'formikBag' might be stale.
      formikBag.setStatus(err);
      this.setState({ error: err });
    }

    formikBag.setSubmitting(false);
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    // status,
  }) => {
    const { history, redirect } = this.props;
    const { error } = this.state;

    return (
      <KeyboardAvoidingView
        style={[
          styles.view.form,
          {
            backgroundColor: 'white',
            width: '100%',
            padding: 0,
            margin: 0,
            alignItems: 'center',
            justifyContent: 'space-evenly',
          },
        ]}
        behavior="padding"
      >
        <Header
          name={translate('signup_header')}
          hasCancel
          history={history}
        />

        <KeyboardAwareScrollView
          style={{
            flex: 1,
            width: '100%',
            margin: 0,
          }}
          contentContainerStyle={styles.form.containerScrollable}
        >
          {error !== undefined && (
            <Text
              style={{
                color: 'red',
              }}
            >
              {error}
            </Text>
          )}

          <Input
            label={translate('signin_email')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.email && errors.email ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            leftIconContainerStyle={styles.form.inputIconContainer}
            value={values.email}
            placeholder={translate('signin_email_placeholder')}
            autoCompleteType="email"
            textContentType="emailAddress"
            importantForAutofill="yes"
            leftIcon={(
              <Icon
                name="user"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
              />
            )}
            keyboardType="email-address"
            autoCapitalize="none"
            autoFocus
            onChangeText={(value) => setFieldValue('email', value)}
            onBlur={() => setFieldTouched('email')}
            editable={!isSubmitting}
            errorMessage={touched.email && errors.email ? errors.email : undefined}
          />
          {/* <Input
            containerStyle={{ width: '80%' }}
            value={values.name}
            placeholder={translate('signup_name')}
            // leftIcon={(
            //   <Icon
            //     name="face"
            //     size={24}
            //     color="black"
            //   />
            // )}
            // keyboardType="email-address"
            autoCapitalize="none"
            onChangeText={value => setFieldValue('name', value)}
            onBlur={() => setFieldTouched('name')}
            editable={!isSubmitting}
            errorMessage={touched.name && errors.name ? errors.name : undefined}
          /> */}
          <Input
            label={translate('signin_password')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.password && errors.password ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            leftIconContainerStyle={styles.form.inputIconContainer}
            placeholder={translate('signin_password_placeholder')}
            // autoCompleteType="password"
            textContentType="newPassword"
            passwordRules="required: lower; required: upper; required: digit; minlength: 8;"
            leftIcon={(
              <Icon
                name="lock"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
              />
            )}
            secureTextEntry
            password
            autoCapitalize="none"
            value={values.password}
            onChangeText={(value) => setFieldValue('password', value)}
            onBlur={() => setFieldTouched('password')}
            editable={!isSubmitting}
            errorMessage={touched.password && errors.password ? errors.password : undefined}
          />
          <Input
            label={translate('signup_password2')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.password2 && errors.password2 ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            leftIconContainerStyle={styles.form.inputIconContainer}
            placeholder={translate('signup_password2_placeholder')}
            textContentType="newPassword"
            passwordRules="required: lower; required: upper; required: digit; minlength: 8;"
            leftIcon={(
              <Icon
                name="lock"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
              />
            )}
            secureTextEntry
            password
            autoCapitalize="none"
            value={values.password2}
            onChangeText={(value) => setFieldValue('password2', value)}
            onBlur={() => setFieldTouched('password2')}
            editable={!isSubmitting}
            errorMessage={touched.password2 && errors.password2 ? errors.password2 : undefined}
          />
          <Button
            title={translate('signup_header')}
            containerStyle={[styles.buttonfsf.primaryContainer, { marginTop: 30 }]}
            buttonStyle={styles.buttonfsf.primary}
            disabledStyle={styles.buttonfsf.primaryDisabled}
            titleStyle={styles.buttonfsf.primaryTitle}
            disabledTitleStyle={styles.buttonfsf.primaryTitleDisabled}
            onPress={handleSubmit}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
          <Button
            clear
            title={translate('menu_signin')}
            containerStyle={[styles.buttonfsf.secondaryContainer, { marginTop: 20 }]}
            buttonStyle={styles.buttonfsf.secondary}
            titleStyle={styles.buttonfsf.secondaryTitle}
            onPress={() => history.push(`/signin${redirect}`)}
          />
          {/* <Button
            clear
            title={translate('button_cancel')}
            containerStyle={[styles.buttonfsf.secondaryContainer, { marginTop: 20 }]}
            buttonStyle={styles.buttonfsf.secondary}
            titleStyle={styles.buttonfsf.secondaryTitle}
            onPress={() => history.push('/ai-agents')}
          /> */}
        </KeyboardAwareScrollView>
      </KeyboardAvoidingView>
    );
  }

  render() {
    return (
      <Formik
        enableReinitialize
        initialValues={{
          email: '',
          password: '',
          password2: '',
          name: '',
        }}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

SignUpForm.defaultProps = {
  redirect: '/',
};

SignUpForm.propTypes = {
  redirect: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default SignUpForm;
